import {MyFirestore} from "./firb";
import {AuthFirestore} from "./firb-auth";
import firebase from 'firebase'
// //
// const configOptions = {
//   apiKey: 'AIzaSyCt163Hj21Ebig33DDaYUm2RXBBLNbKNFc',
//   authDomain: 'stroybots-prod.firebaseapp.com',
//   databaseURL: 'https://stroybots-prod.firebaseio.com',
//   storageBucket: 'stroybots-prod.appspot.com',
//   projectId: 'stroybots-prod',
//   messagingSenderId: '326501786024',
//   appId: '1:326501786024:web:6822c24b695e4a19d6bd9ds',
//   measurementId: 'G-DSGR1M5854',
// };
//
//
// export const apiAuthUrl = 'https://stroybot-api-prod.herokuapp.com/api/v1/auth/get_auth/'
// export const apiServerUrl = 'https://stroybots-backend-api-prod.stroybots.ru'
// export const apiUrl = 'https://proxy-functions.stroybots.ru/?url=https%3A%2F%2Fus-central1-stroybots-prod.cloudfunctions.net';
// export const isCache = false;
// export const isApiRuleIgnore = false



// export const apiUrl = 'https://functions-app.stroybots.ru:9099'
//

const configOptions = {
  apiKey: "AIzaSyA-gD8ddrSFxAt5i17BpYyIGr2f0ajWhmE",
  authDomain: "fir-stroybots.firebaseapp.com",
  databaseURL: "https://fir-stroybots.firebaseio.com",
  projectId: "fir-stroybots",
  storageBucket: "fir-stroybots.appspot.com",
  messagingSenderId: "873263126271",
  appId: "1:873263126271:web:fc7ce7630e41d652915eca",
  measurementId: 'G-7ZY6BYNB9F',
};

export const isApiRuleIgnore = true
export const isCache = false;
export const apiAuthUrl = 'https://stroybot-api-prod.herokuapp.com/api/v1/auth/get_auth/'
export const apiServerUrl = 'https://stroybots-backend-api.stroybots.ru'

// export const apiUrl = 'https://stroybots-firebase-mongo-web-dev.stroybots.ru/functions';
// // //
// export const uploadUrl = 'https://stroybots-firebase-mongo-web-dev.stroybots.ru/files/upload/'
// export const myFirestore = new MyFirestore('https://stroybots-firebase-mongo-web-dev.stroybots.ru');
// export const authFirestore = new AuthFirestore('https://stroybots-firebase-mongo-web-dev.stroybots.ru/auth')



export const apiUrl = 'https://stroybots-firebase-mongo-web.stroybots.ru/functions';

export const myFirestore = new MyFirestore('https://stroybots-firebase-mongo-web.stroybots.ru');
export const authFirestore = new AuthFirestore('https://stroybots-firebase-mongo-web.stroybots.ru/auth')
export const uploadUrl = 'https://stroybots-firebase-mongo-web.stroybots.ru/files/upload/'

window.myFirestore = myFirestore;
window.authFirestore = authFirestore;

firebase.initializeApp(configOptions);

// firebase.initializeApp(configOptions);

//
// export const myFirestore =  new MyFirestore('http://localhost:3000');
// window.myFirestore = myFirestore

//
// myFirestore.useEmulator("stroybots-firestore-firebase.stroybots.ru", 443);
// myFirestore.settings({ host: 'stroybots-firestore-firebase.stroybots.ru', ssl: true });
//


// PROD ENV
//
// let config = {
//   apiUrl: 'https://stroybots-functions-firebase.stroybots.ru/fir-stroybots/us-central1',
//   isApiRuleIgnore: true,
//   apiServerUrl: 'https://stroybots-functions-firebase.stroybots.ru/fir-stroybots/us-central1',
//   apiAuthUrl: 'https://stroybots-functions-firebase.stroybots.ru/fir-stroybots/us-central1'
// }
// const currentServer = localStorage.getItem('server')
// if (currentServer === 'rk') {
//   const configOptions = {
//     apiKey: "AIzaSyA-gD8ddrSFxAt5i17BpYyIGr2f0ajWhmE",
//     authDomain: "fir-stroybots.firebaseapp.com",
//     databaseURL: "https://fir-stroybots.firebaseio.com",
//     projectId: "fir-stroybots",
//     storageBucket: "fir-stroybots.appspot.com",
//     messagingSenderId: "873263126271",
//     appId: "1:873263126271:web:fc7ce7630e41d652915eca",
//     measurementId: 'G-7ZY6BYNB9F',
//   };
//
//   firebase.initializeApp(configOptions);
//
//   config = {
//     apiUrl: 'https://stroybots-functions-firebase.stroybots.ru/fir-stroybots/us-central1',
//     isApiRuleIgnore: true,
//     isCache: true,
//     apiServerUrl: 'https://stroybots-functions-firebase.stroybots.ru/fir-stroybots/us-central1',
//     apiAuthUrl: 'https://stroybots-functions-firebase.stroybots.ru/fir-stroybots/us-central1'
//   }
//
//
//   authFirestore.useEmulator("https://stroybots-auth-firebase.stroybots.ru");
//   firebase.functions().useEmulator("stroybots-functions-firebase.stroybots.ru", 443);
//   firebase.functions().useFunctionsEmulator('https://stroybots-functions-firebase.stroybots.ru')
//   myFirestore.settings({host: 'stroybots-firestore-firebase.stroybots.ru', ssl: true});
//   firebase.storage().useEmulator('stroybots-storage-firebase.stroybots.ru', 443, {ssl: true})
// } else {
//   const configOptions = {
//     apiKey: 'AIzaSyCt163Hj21Ebig33DDaYUm2RXBBLNbKNFc',
//     authDomain: 'stroybots-prod.firebaseapp.com',
//     databaseURL: 'https://stroybots-prod.firebaseio.com',
//     storageBucket: 'stroybots-prod.appspot.com',
//     projectId: 'stroybots-prod',
//     messagingSenderId: '326501786024',
//     appId: '1:326501786024:web:6822c24b695e4a19d6bd9ds',
//     measurementId: 'G-DSGR1M5854',
//   };
//
//   config = {
//     // apiUrl: 'https://stroybots-functions-firebase.stroybots.ru/fir-stroybots/us-central1',
//     // isApiRuleIgnore: true,
//     // apiServerUrl: 'https://stroybots-functions-firebase.stroybots.ru/fir-stroybots/us-central1',
//     // apiAuthUrl: 'https://stroybots-functions-firebase.stroybots.ru/fir-stroybots/us-central1'
//     apiAuthUrl: 'https://stroybot-api-prod.herokuapp.com/api/v1/auth/get_auth/',
//     apiServerUrl: 'https://stroybots-backend-api-prod.stroybots.ru',
//     apiUrl: 'https://proxy-functions.stroybots.ru/?url=https%3A%2F%2Fus-central1-stroybots-prod.cloudfunctions.net',
//     isCache: false,//replace
//     isApiRuleIgnore: false
//   }
// //
//
//   firebase.initializeApp(configOptions);
// }
// //
// //
// export const apiAuthUrl = config.apiAuthUrl
// export const apiServerUrl = config.apiServerUrl
// export const apiUrl = config.apiUrl
// export const isCache = config.isCache;
// export const isApiRuleIgnore = config.isApiRuleIgnore;
// localStorage.removeItem('server')


// const firebaseConfig = {
//   projectId: 'stroybots-prod',
// };
// firebase.initializeApp(configOptions);
//
// myFirestore.useEmulator("localhost", 8080);
// authFirestore.useEmulator("http://localhost:3005/");
// const database = myFirestore;
// database.useEmulator("functions-app.stroybots.ru", 8080);
//
// const authentication = authFirestore;
//
// authentication.useEmulator("http://functions-app.stroybots.ru:9099");
//
// var db = myFirestore;
// db.useEmulator("functions-app.stroybots.ru", 8080);
// firebase.functions().useEmulator("functions-app.stroybots.ru", 5001);
// const auth = authFirestore;
// auth.useEmulator("https://functions-app.stroybots.ru:9099");

export default firebase;



// WEBPACK FOOTER //
// ./src/plugins/firebase.js